export const RESET = 'USERDATAEMPLOYEE_UPDATE_RESET'
export const SET_ERROR = 'USERDATAEMPLOYEE_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'USERDATAEMPLOYEE_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'USERDATAEMPLOYEE_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'USERDATAEMPLOYEE_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'USERDATAEMPLOYEE_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'USERDATAEMPLOYEE_UPDATE_UPDATE_RETRIEVED'
